import * as d3 from 'd3';

export const drawPieChart = (data, isAdminView) => {
	const outerRadius = isAdminView ? 105 : 132;
	const innerRadius = 70;

	const width = 2 * outerRadius;
	const height = 2 * outerRadius;
	const totalApiCalls = data.reduce((acc, item) => { return acc + item.volume }, 0);

	d3.select('#pie-container')
		.select('svg')
		.remove();
	d3.select('#legends')
		.select('svg')
		.remove();

	const svg = d3
		.select('#pie-container')
		.append('svg')
		.attr('width', width)
		.attr('height', height)
		.attr('viewBox', `0 0 ${width} ${height}`)
		.append('g')
		.attr('transform', `translate(${width / 2}, ${height / 2})`)

	const arcGenerator = d3
		.arc()
		.innerRadius(innerRadius)
		.outerRadius(outerRadius);

	const pieGenerator = d3
		.pie()
		.padAngle(0)
		.value((d) => d.volume);

	svg.append("g")
		.selectAll()
		.data(pieGenerator(data))
		.join("path")
		.attr("fill", d => d.data.color)
		.attr("d", arcGenerator)
		.append("title")
		.text(d => `jejejejej${d.data.volume}`);

	svg.append("g")
		.attr("font-family", "sans-serif")
		.attr("font-size", 12)
		.attr("text-anchor", "middle")
		.attr("fill", "#ffffff")
		.selectAll()
		.data(pieGenerator(data))
		.join("text")
		.attr("transform", d => `translate(${arcGenerator.centroid(d)})`)
		.call(text => text.filter(d => (d.endAngle - d.startAngle) > 0.25).append("tspan")
			.attr("x", 0)
			.attr("y", "0.7em")
			.text(d => d.data.volume));

	svg.append('text')
		.attr('x', '0')
		.attr('y', '0')
		.style('fill', '#726c66')
		.text(`Total API calls`)
		.attr('text-anchor', 'middle')
		.style('alignment-baseline', 'middle')
		.style('font-size', '12px')
	svg.append('text')
		.attr('x', '0')
		.attr('y', '20')
		.style('fill', '#262321')
		.attr('text-anchor', 'middle')
		.style('alignment-baseline', 'middle')
		.style('font-weight', 'bold')
		.style('font-size', '12px')
		.text(`${totalApiCalls.toLocaleString()}`)
}
